/**
 * Paramètres de l'application côté client.
 * Équivalent frontend de la section "Ressources" dans appsettings.json.
 *
 * Priorité pour UrlBase :
 *  1. REACT_APP_IMAGES_BASE_URL (variable d'environnement)
 *  2. REACT_APP_API_BASE_URL    (variable d'environnement)
 *  3. window.location.origin   (détection automatique en production)
 */
const obtenirUrlBase = (): string => {
  const imagesBaseUrl = process.env.REACT_APP_IMAGES_BASE_URL;
  if (imagesBaseUrl && imagesBaseUrl.trim().length > 0) {
    return imagesBaseUrl.replace(/\/$/, '');
  }
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  if (apiBaseUrl && apiBaseUrl.trim().length > 0) {
    return apiBaseUrl.replace(/\/$/, '');
  }
  return window.location.origin;
};

const AppSetting = {
  /** URL de base du serveur (images, API). Correspond à Ressources:UrlBase dans appsettings.json. */
  UrlBase: obtenirUrlBase(),
};

export default AppSetting;
